import { printProfileIdFormat } from "@redotech/redo-fulfillment-id";
import {
  printProfileSchema,
  printProfileSettingsSchema,
} from "@redotech/redo-fulfillment-outbound-labels-common/print-settings";
import * as z from "zod";

export const savePrintProfile = {
  name: "savePrintProfile" as const,
  input: z.object({
    profileId: printProfileIdFormat.schema.optional(),
    name: z.string().trim().min(1),
    settings: printProfileSettingsSchema,
  }),
  output: z.object({ printProfile: printProfileSchema }),
};
